<template lang="pug">
  base-container
    avue-crud(
      ref="crud",
      :data="data",
      :table-loading="loading",
      :option="option",
      :page.sync="page",
      @search-change="searchChange",
      @search-reset="searchReset",
      @current-change="currentChange",
      @size-change="sizeChange",
      @refresh-change="refreshChange",
      @on-load="onLoad"
    )
</template>
<script>
/**
 * 内容管理-协议管理-列表
 */
import { getQuestionList } from '@/api/content'

export default {
  name: 'QuestionList',
  components: {},
  data() {
    return {
      form: {},
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        indexLabel: '编号',
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        searchShow: true,
        columnBtn: false,
        stripe: true,
        searchSpan: 8,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: false,
        menu: false,
        column: [
          {
            label: '编号',
            prop: 'id'
          },
          {
            label: '问题详情',
            prop: 'questionName',
            overHidden: true
          }
        ]
      }
    }
  },
  methods: {
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      this.loading = true
      getQuestionList(page.currentPage, page.pageSize, params)
        .then((res) => {
          const data = res.data
          this.page.total = res.total
          this.data = data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
